<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto max-w-screen-xl flex-col">
      <component :is="heading" v-if="title">{{ title }}</component>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  heading?: string;
  title?: string;
  subtitle?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)]",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-5 lg:py-10",
  ];
});
</script>
